import type { IconSvgObject } from './types';

const ThreeDMoveIcon: IconSvgObject = [
  ["path", { d: "M12 14L17.5 19M12 14L6.5 19M12 14V7", stroke: "currentColor", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M2 21.5L4.5 16L8 22L2 21.5Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M22 21.5L19.5 16L16 22L22 21.5Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M12.0404 2L8.5 6.96857L15.5 7L12.0404 2Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }]
];

export default ThreeDMoveIcon;
